<template>
  <div class="mb-3">
    <h6>Tasks </h6>
    <div v-for="(task, index) in tasks" :key="index" :class="[task.error ? 'error' : 'no-error']"
    class="mb-3 p-1 rounded bg-light">
        <div class="input-group mb-3">
          <div class="input-group-prepend">
            <span class="input-group-text">Task</span>
          </div>
          <select v-model="tasks[index].method" @change="changeTask(index)" class="form-control">
              <option v-for="(item,i) in available_tasks" :value="item" :key="i">{{item}}</option>
          </select>
          <div class="input-group-append">
            <button @click="moveTaskUp(index)" class="btn btn-sm btn-outline-secondary" title="Move Up"><i class="fa fa-chevron-up" aria-hidden="true"></i></button>
            <button @click="moveTaskDown(index)" class="btn btn-sm btn-outline-secondary" title="Move Down"><i class="fa fa-chevron-down" aria-hidden="true"></i></button>
            <button @click="removeTask(index)" class="btn btn-sm btn-outline-danger" title="Delete"><i class="fa fa-trash" aria-hidden="true"></i></button>
          </div>
        </div>
        <component v-bind:is="tasks[index].method" :data="tasks[index].data" :actions="actions"></component>
    </div>
    <button @click="addTask" class="btn btn-outline-success">Add New Task</button>
  </div>
</template>

<style>
.error{
  border-style: dashed;
  border-width: 3px;
  border-color:red;
}
.no-error{
  border-style: solid;
  border-color: #10e22c;
}
</style>

<script>
import Vue from 'vue'

// tasks
import ArrayOperation from '@/components/tasks/ArrayOperation.vue'
import ArithmeticOperation from '@/components/tasks/ArithmeticOperation.vue'
import StoreData from '@/components/tasks/StoreData.vue'
//import CaptureData from '@/components/tasks/CaptureData.vue'
import ValidateInput from '@/components/tasks/ValidateInput.vue'
import Compare from '@/components/tasks/Compare.vue'
import CreateVariable from '@/components/tasks/CreateVariable.vue'
import LeaderBoard from './tasks/LeaderBoard.vue'
import HttpRequest from '@/components/tasks/HttpRequest.vue'
import Publish from '@/components/tasks/Publish.vue'


//chat tasks
import AnswerCallbackQuery from '@/components/tasks/AnswerCallbackQuery.vue'
import BanChatMember from '@/components/tasks/BanChatMember.vue'
import CopyMessage from '@/components/tasks/CopyMessage.vue'
import CreateChatInviteLink from '@/components/tasks/CreateChatInviteLink.vue'
import DeleteMessage from '@/components/tasks/DeleteMessage.vue'
import EditMessageText from '@/components/tasks/EditMessageText.vue'
import EditMessageCaption from '@/components/tasks/EditMessageCaption.vue'
import EditMessageInlineKeyboard from '@/components/tasks/EditMessageInlineKeyboard.vue'
import EditMessageMedia from '@/components/tasks/EditMessageMedia.vue'
import ForwardMessage from '@/components/tasks/ForwardMessage.vue'
import GetChatAdministrators from '@/components/tasks/GetChatAdministrators.vue'
import GetChatMemberCount from '@/components/tasks/GetChatMemberCount.vue'
import IsChatMember from '@/components/tasks/IsChatMember.vue'
import KickExpiredPrimeMembers from '@/components/tasks/KickExpiredPrimeMembers.vue'
import Random from '@/components/tasks/Random.vue'
import Reply from '@/components/tasks/Reply.vue'
import SendAnimation from '@/components/tasks/SendAnimation.vue'
import SendAudio from '@/components/tasks/SendAudio.vue'
import SendContact from '@/components/tasks/SendContact.vue'
import SendDocument from '@/components/tasks/SendDocument.vue'
import SendLocation from '@/components/tasks/SendLocation.vue'
import SendMessage from '@/components/tasks/SendMessage.vue'
import SendPhoto from '@/components/tasks/SendPhoto.vue'
import SendPoll from '@/components/tasks/SendPoll.vue'
import SendQuiz from '@/components/tasks/SendQuiz.vue'
import SendVenue from '@/components/tasks/SendVenue.vue'
import SendVideo from '@/components/tasks/SendVideo.vue'
import SendVideoNote from '@/components/tasks/SendVideoNote.vue'
import SendVoice from '@/components/tasks/SendVoice.vue'
import SetChatPermissions from '@/components/tasks/SetChatPermissions.vue'
import UnBanChatMember from '@/components/tasks/UnBanChatMember.vue'



export default {
  name: "Task",
  components:{
    AnswerCallbackQuery,
    ArithmeticOperation,
    ArrayOperation,
    BanChatMember,
    Compare,
    CopyMessage,
    CreateChatInviteLink,
    CreateVariable,
    DeleteMessage,
    EditMessageText,
    EditMessageCaption,
    EditMessageInlineKeyboard,
    EditMessageMedia,
    ForwardMessage,
    GetChatAdministrators,
    GetChatMemberCount,
    HttpRequest,
    IsChatMember,
    KickExpiredPrimeMembers,
    LeaderBoard,
    Publish,
    Random,
    Reply,
    SendAnimation,
    SendAudio,
    SendContact,
    SendDocument,
    SendLocation,
    SendMessage,
    SendPhoto,
    SendPoll,
    SendQuiz,
    SendVenue,
    SendVideo,
    SendVideoNote,
    SendVoice,
    SetChatPermissions,
    StoreData,
    UnBanChatMember,
    ValidateInput
  },
  props: {
    tasks: Array,
    actions: Object,
  },
  data: function(){
    return{
      available_tasks: [
        'AnswerCallbackQuery',
        'ArithmeticOperation',
        'ArrayOperation',
        'BanChatMember',
        'Compare',
        'CopyMessage',
        'CreateChatInviteLink',
        'CreateVariable',
        'DeleteMessage',
        'EditMessageText',
        'EditMessageCaption',
        'EditMessageInlineKeyboard',
        'EditMessageMedia',
        'ForwardMessage',
        'GetChatAdministrators',
        'GetChatMemberCount',
        'HttpRequest',
        'IsChatMember',
        'KickExpiredPrimeMembers',
        'LeaderBoard',
        'Random',
        'Reply',
        'SendAnimation',
        'SendAudio',
        'SendContact',
        'SendDocument',
        'SendLocation',
        'SendMessage',
        'SendPhoto',
        'SendPoll',
        'SendQuiz',
        'SendVenue',
        'SendVideo',
        'SendVideoNote',
        'SendVoice',
        'SetChatPermissions',
        'StoreData',
        'UnBanChatMember',
        'ValidateInput'
      ],
      task_data:{
        AnswerCallbackQuery: {text: null, show_alert: true},
        ArithmeticOperation: {result: null, val1: null, operator: '+', val2: null},
        ArrayOperation: {element: 0, position: 0, method: 'append', list: null, error: "Element present/absent present in list"},
        BanChatMember: {user_id: null, chat_id: null},
        Compare: {lhs: null, operator: 'equal to', rhs: null, else_tasks: []},
        CopyMessage: {to: ""},
        CreateChatInviteLink: {chat_id: null},
        CreateVariable: {values: [{key: null, value: null}]},
        DeleteMessage: {chat_id: '{{chat_id}}', message_id: '{{incoming_message_id}}'},
        EditMessageText: {chat_id: '{{user_id}}', message_id: '{{incoming_message_id}}', text: null, reply_markup: null},
        EditMessageCaption: {chat_id: '{{user_id}}', message_id: '{{incoming_message_id}}', caption: null, reply_markup: null},
        EditMessageInlineKeyboard: {chat_id: '{{user_id}}', message_id: '{{incoming_message_id}}', reply_markup: null},
        EditMessageMedia:{chat_id:'{{user_id}}',message_id:'{{incoming_message_id}}',
                          media:{type:'photo',media:null,caption:null},reply_markup: null},
        ForwardMessage: {to: ""},
        GetChatAdministrators: {chat_id: null},
        GetChatMemberCount: {chat_id: null},
        HttpRequest: {method: 'get', url:null, headers: "{}", headers_present: false, body:"{}", error: null},
        IsChatMember: {chat_id: null, else_tasks: []},
        KickExpiredPrimeMembers: {chat_id: null},
        LeaderBoard: {chat_id: null, count: null},
        Publish: {text: null, reply_markup: null},
        Random: {random_var: null, list_var: null},
        Reply: {text: null, reply_markup: null},
        SendAnimation: {to: '{{chat_id}}', animation: null, caption: null, reply_markup: null},
        SendAudio: {to: '{{chat_id}}', audio: null, caption: null, reply_markup: null},
        SendContact: {to: '{{chat_id}}', phone_number: null, first_name: null, last_name: null, reply_markup: null},
        SendDocument: {to: '{{chat_id}}', document: null, caption: null, reply_markup: null},
        SendLocation: {to: '{{chat_id}}', latitude: null, longitude: null, reply_markup: null},
        SendMessage: {to: '{{chat_id}}', text: null, reply_markup: null},
        SendPhoto: {to: '{{chat_id}}', photo: null, caption: null, reply_markup: null},
        SendPoll: {to: '{{chat_id}}', question: null, options:[null,null], is_anonymous:true, allows_multiple_answers:false, reply_markup: null},
        SendQuiz: {to: '{{chat_id}}', question: null, options:[null,null], is_anonymous:true, correct_option_id:0, type:'quiz',reply_markup: null},
        SendVenue: {to: '{{chat_id}}', latitude: null, longitude: null, title: null, address: null, reply_markup: null},
        SendVideo: {to: '{{chat_id}}', video: null, caption: null, reply_markup: null},
        SendVideoNote: {to: '{{chat_id}}', video_note: null, caption: null, reply_markup: null},
        SendVoice: {to: '{{chat_id}}', voice: null, caption: null, reply_markup: null},
        SetChatPermissions: {chat_id: null, permissions: {can_send_messages: true, can_send_media_messages: true, can_send_polls: true, can_send_other_messages: true, can_add_web_page_previews: true, can_change_info: true, can_invite_users: true, can_pin_messages: true}},
        StoreData: {values: [{key: null, value: null}]},
        UnBanChatMember: {user_id: null, chat_id: null},
        ValidateInput: {validate: null}
      }
    }
  },
  methods:{
    addTask: function(){
      this.tasks.push({method: 'Reply', data:{text: null, reply_markup: null}, error:false})
    },
    removeTask: function(index){
      this.removeButtonsInTask(this.tasks[index])
      this.tasks.splice(index,1)
    },
    moveTaskUp: function(index) {
      if(index != 0){
        let upper_task = this.tasks[index-1]
        Vue.set(this.tasks, index-1, this.tasks[index])
        Vue.set(this.tasks, index, upper_task)
      }
    },
    moveTaskDown: function(index) {
      if(index != this.tasks.length-1){
        let down_task = this.tasks[index+1]
        Vue.set(this.tasks, index+1, this.tasks[index])
        Vue.set(this.tasks, index, down_task)
      }
    },
    changeTask: function(index){
      this.removeButtonsInTask(this.tasks[index])
      let data = this.task_data[this.tasks[index].method];
      let newData = JSON.parse(JSON.stringify(data));
      this.tasks[index].data = newData;
    },
    removeButtonsInTask: function(task){
      var btns = []
      var clbks = []

      if('reply_markup' in task.data && task.data.reply_markup != null){
        if('keyboard' in task.data.reply_markup){
          let keyboard = task.data.reply_markup.keyboard;
          for (var i = 0; i < keyboard.length; i++) {
            for (var j = 0; j < keyboard[i].length; j++) {
              btns.push(keyboard[i][j]);
            }
          }
        }
        if('inline_keyboard' in task.data.reply_markup){
          let inline_keyboard = task.data.reply_markup.inline_keyboard;
          for (i = 0; i < inline_keyboard.length; i++) {
            for (j = 0; j < inline_keyboard[i].length; j++) {
              if(inline_keyboard[i][j].type == 'callback_data')
                clbks.push(inline_keyboard[i][j]);
            }
          }
        }
      }

      btns.forEach(function(btn){
        this.actions.reply_buttons = this.actions.reply_buttons.filter(function (value){
          return value.button.text != btn.text || value.button.id != btn.id;
        }.bind(this));
      }.bind(this));
      clbks.forEach(function(btn){
        this.actions.callbacks = this.actions.callbacks.filter(function (value){
          return value.button.id != btn.id || value.button.text != btn.text || value.button.callback_data != btn.callback_data;
        }.bind(this));
      }.bind(this));

      if('else_tasks' in task.data){
        task.data.else_tasks.forEach(function(else_task){
          this.removeButtonsInTask(else_task)
        }.bind(this));
      }
    },
  },
}
</script>
